import { ChevronDown } from '@griply/assets';
import { SetupChecklistItemId } from '@griply/utils';
import React from 'react';
import { Collapse } from 'shared/components/ui/collapse';
import { Colors, Sizes } from 'shared/components/ui/icon-button';
import {
  ProgressBar,
  ProgressBarVariants,
} from 'shared/components/ui/progress-bar';

import * as Styled from './setup-checklist-card.style';
import { SetupChecklistMenu } from './setup-checklist-menu';
import { SetupChecklistRow } from './setup-checklist-row';

export type SetupChecklistDisplayItem = {
  id: SetupChecklistItemId;
  label: string;
  complete: boolean;
  onNavigate?: () => void;
};

export type SetupChecklistCardProps = {
  title: string;
  items: SetupChecklistDisplayItem[];
  completeCount: number;
  totalCount: number;
  collapsed: boolean;
  onToggleCollapse: () => void;
  onHide: () => void;
  hideLabel: string;
};

export const SetupChecklistCard: React.FC<SetupChecklistCardProps> = ({
  title,
  items,
  completeCount,
  totalCount,
  collapsed,
  onToggleCollapse,
  onHide,
  hideLabel,
}) => {
  return (
    <Styled.Container>
      <Styled.Header>
        <Styled.TitleBar>
          <Styled.Title>{title}</Styled.Title>

          <Styled.Actions>
            <SetupChecklistMenu onHide={onHide} hideLabel={hideLabel} />
            <Styled.HeaderButton
              icon={ChevronDown}
              onClick={onToggleCollapse}
              rotation={collapsed ? 180 : 0}
              color={Colors.Inherit}
              size={Sizes.Small}
              noHover
              aria-label={title}
            />
          </Styled.Actions>
        </Styled.TitleBar>

        <ProgressBar
          completed={completeCount}
          total={totalCount}
          variant={ProgressBarVariants.Inverse}
        />
      </Styled.Header>

      <Collapse isOpen={!collapsed}>
        <Styled.List>
          {items.map((item) => (
            <SetupChecklistRow
              key={item.id}
              label={item.label}
              complete={item.complete}
              onNavigate={item.onNavigate}
            />
          ))}
        </Styled.List>
      </Collapse>
    </Styled.Container>
  );
};
